// This is generated.  Alter it in blockGroups/actionElements/types/DownloadButton.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    const { forAction, children = [] } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );

    if (accessRestrictions.hidden) return [{}, {}];

    const accessContext = {
      get: { value: true, observedLocation: hNode.blockId },
      post: { value: true, observedLocation: hNode.blockId },
      patch: { value: false, observedLocation: hNode.blockId },
      put: { value: false, observedLocation: hNode.blockId },
      remove: { value: false, observedLocation: hNode.blockId },
    };

    const normalizedAction = actionUtils.normalizeAction(forAction);
    const targetRelationSchema = {
      report: {
        generate: Type.Object(
          {},
          {
            // DownloadButton grants report.generate access when the button is visible because users who can
            // access a cached-online download button should always be able to use server-side export.
            // This is a synthetic access shell for report.generate, not a canonical input schema.
            title: 'generate',
            additionalProperties: true,
            ...(normalizedAction ? { 'x-forAction': normalizedAction } : {}),
            'x-accessRestrictions': { ...accessRestrictions, readOnly: false },
            'x-accessContext': accessContext,
          },
        ),
      },
    };

    // Aggregate child contributions (list columns for export)
    let mergedChildSubDD = {};
    let mergedChildPartialMap = {};

    for (const child of children) {
      const [cSub = {}, cPartial = {}] = context.extractFromChild(
        child,
        context,
        accessRestrictions,
      ) || [{}, {}];
      mergedChildSubDD = merge(mergedChildSubDD, cSub);
      mergedChildPartialMap = Object.assign(mergedChildPartialMap, cPartial);
    }

    // View-only block: only pass through child subDataDictionary contributions.
    // Do NOT create or merge into the canonical [namespace][relation] slot.
    // Canonical schemas are defined by Form blocks.
    // Export column definitions are for UI/export purposes only.
    return [
      merge(targetRelationSchema, mergedChildSubDD),
      mergedChildPartialMap,
    ];
  },
};
moduleRegistration.registerHNodeType(
  'actionElements',
  'DownloadButton',
  module.exports,
);
